import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import get from 'lodash.get';
import PropTypes from 'prop-types';
import isMobile from 'ismobilejs';

// This exists as a TS type in `tracking-types.ts`
export var trackingPropType = PropTypes.shape({
  item: PropTypes.string,
  item_type: PropTypes.string,
  category: PropTypes.string,
  typeform_version: PropTypes.string,
  typeform_property: PropTypes.string,
  label: PropTypes.string,
  unique_pageview_id: PropTypes.string,
  unique_sectionview_id: PropTypes.string,
  attribution_user_id: PropTypes.string,
  page: PropTypes.string,
  tracking_session_id: PropTypes.string
});

// This exists as a TS type in `tracking-types.ts`
export var experimentTrackingPropType = PropTypes.shape({
  eventName: PropTypes.string
});
export function setTrackingProperties(tracking) {
  var isMobileDevice = isMobile(window.navigator).any;
  var properties = _objectSpread({}, tracking);
  properties.typeform_version = isMobileDevice ? 'mobile' : 'v2';
  return properties;
}
export function onTrackItemClickEvent(config, trackEvent, trackExperimentEvent) {
  var tracking = get(config, 'tracking');
  var experimentTracking = get(config, 'experimentTracking');
  if (tracking) {
    var properties = setTrackingProperties(tracking);
    trackEvent('item_clicked', _objectSpread(_objectSpread({}, properties), {}, {
      link_url: get(config, 'url'),
      location: properties.location || document.location.href
    }));
  }
  if (trackExperimentEvent && experimentTracking) {
    trackExperimentEvent({
      name: experimentTracking.eventName
    });
  }
}